module.exports = __webpack_public_path__ + "static/media/ChickenSans-Regular.8a22d41e.woff2";